import { Flex, Text } from "@chakra-ui/react";
import { IconReceive, IconSendWallet } from "icons";

const WalletButtons = ({ setActiveSection }: { setActiveSection: (section: 'receive' | 'send' | 'wallet') => void }) => {
  return (
    <Flex
      gap={2}
      w="full"
      justifyContent="center"
      alignItems="center"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        background="linear-gradient(225deg, rgba(109, 241, 229, 0.2) 0%, rgba(79, 197, 186, 0.2) 18%, rgba(38, 166, 154, 0.2) 73%, rgba(26, 116, 107, 0.2) 100%)"
        borderRadius="4px"
        gap="2"
        p="3"
        w="full"
        textTransform="uppercase"
        fontFamily="heading"
        onClick={() => setActiveSection('receive')}
        position="relative"
        _before={{
          content: '""',
          position: 'absolute',
          inset: 0,
          padding: '2px',
          background: 'linear-gradient(360deg, rgba(76, 194, 183, 0.6) 0%, rgba(76, 194, 183, 0.24) 100%)',
          borderRadius: '4px',
          zIndex: -1,
          mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
          maskComposite: 'exclude',
        }}
        cursor="pointer"
        _hover={{
          background: "linear-gradient(225deg, rgba(109, 241, 229, 0.4) 0%, rgba(79, 197, 186, 0.4) 18%, rgba(38, 166, 154, 0.4) 73%, rgba(26, 116, 107, 0.4) 100%)"
        }}
        transition="all 0.2s ease-in-out"
      >
        <Text
          fontSize={{ base: '12px', md: '16px' }}
          lineHeight={{ base: '16px', md: '100%' }}
          fontWeight="400"
          color="rgba(53, 255, 236, 0.8)"
        >
          Receive
        </Text>
        <IconReceive 
          width={{ base: '12px', md: '16px' }}
          height={{ base: '12px', md: '16px' }}
          __css={{
            path: {
              fill: 'rgba(53, 255, 236, 0.8)'
            }
          }}
          mb="1"
        />
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        background="linear-gradient(225deg, rgba(109, 241, 229, 0.2) 0%, rgba(79, 197, 186, 0.2) 18%, rgba(38, 166, 154, 0.2) 73%, rgba(26, 116, 107, 0.2) 100%)"
        borderRadius="4px"
        gap="2"
        w="full"
        p="3"
        position="relative"
        _before={{
          content: '""',
          position: 'absolute',
          inset: 0,
          padding: '2px',
          background: 'linear-gradient(360deg, rgba(76, 194, 183, 0.6) 0%, rgba(76, 194, 183, 0.24) 100%)',
          borderRadius: '4px',
          zIndex: -1,
          mask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
          maskComposite: 'exclude',
        }}
        textTransform="uppercase"
        fontFamily="heading"
        onClick={() => setActiveSection('send')}
        cursor="pointer"
        _hover={{
          background: "linear-gradient(225deg, rgba(109, 241, 229, 0.4) 0%, rgba(79, 197, 186, 0.4) 18%, rgba(38, 166, 154, 0.4) 73%, rgba(26, 116, 107, 0.4) 100%)"
        }}
        transition="all 0.2s ease-in-out"
      >
        <Text
          fontSize={{ base: '12px', md: '16px' }}
          lineHeight={{ base: '16px', md: '100%' }}
          fontWeight="400"
          color="rgba(53, 255, 236, 0.8)"
        >
          Send
        </Text>
        <IconSendWallet 
          width={{ base: '12px', md: '16px' }}
          height={{ base: '12px', md: '16px' }}
          __css={{
            path: {
              fill: 'rgba(53, 255, 236, 0.8)'
            }
          }}
          mb="1"
        />
      </Flex>
    </Flex>
  )
}

export default WalletButtons;
